import { createContext } from 'react';
/**
 * Wrap buttons in its Provider to show them as full-width list rows (`{ onAction }`, e.g. in a
 * MobileSheet) or as toolbar icons (`{ icon: true }`).
 * @export
 */
const ButtonListContext = createContext(null);
export default ButtonListContext;
